module.exports = __webpack_public_path__ + "static/media/mail.41a237ae.svg";